import axios from "./axios"

/**
 * 獲取啟動授權URL
 * @param {*} identityLevel 
 * @param {*} language 
 * @param {*} redirectUri 
 * @returns 
 */
const getAuthorizationUrl = (identityLevel, language, reason, redirectUri) =>{
	return axios.get(`/protected/api/v1/identify/authorization-url?identityLevel=${identityLevel}&language=${language}&reason=${reason}&redirectUri=${redirectUri}`).then(res => res.data)
}

/**
 * 獲取Token
 * @param {*} code 
 * @param {*} redirectUri 
 * @returns 
 */
const getToken = (code, redirectUri) => {
	return axios.get(`/protected/api/v1/identify/token?code=${code}&redirectUri=${redirectUri}`).then(res => res.data)
}

export default {
	getAuthorizationUrl,
	getToken
}